import * as FilterActions from '../actions';

import {createReducer, on} from '@ngrx/store';
import {ItemsReq} from '@app/core/models';

export const FILTER_INITIAL_STATE: ItemsReq = {
  branchId: 0,
  categoryId: 0,
  isMostLiked: false,
  isMostSelling: false,
  isNew: false,
  isRecommended: false,
  isSortedByPriceHighToLow: false,
  isSortedByPriceLowToHigh: false,
  maxPrice: 0,
  minPrice: 0,
  page: 1,
  searchKeyword: '',
  size: 20,
};

export const filterReducer = createReducer(
  FILTER_INITIAL_STATE,
  on(FilterActions.StoreFilterState, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  })
);
